var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{staticClass:"ma-0 pa-0 justify-end",attrs:{"hide-details":""},model:{value:(_vm.mode),callback:function ($$v) {_vm.mode=$$v},expression:"mode"}})}
var staticRenderFns = []

export { render, staticRenderFns }